<template>
  <div>
    <filtered-table v-if="allergenItems" :settings="tableSettings" :staticItems="allergenItems">
      <template v-slot:toggle="data">
        <b-form-checkbox v-model="data.item.isActive" switch @change="onAllergenItemChanged(data.item)" :disabled="!isEditable" />
      </template>
      <template v-slot:isActive="data">
        {{data.item.isActive ? 'Active' : 'Inactive'}}
      </template>
    </filtered-table>
  </div>
</template>

<script>
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'

export default {
  name: "StationAllergens",
  mixins: [CrudOperationsMixin],
  props: [
    'stationId',
    'allergenItems',
    'isEditable'
  ],
  data() {
    return {
      tableSettings: {
        defaultSortColumn: 'name',
        defaultSortOrder: 'asc',
        columns: [
          {
            key: 'toggle',
            name: '',
            visible: true,
            sortable: false
          },
          {
            key: 'isActive',
            name: 'State',
            visible: true,
            sortable: false
          },
          {
            key: 'allergen.category',
            name: 'Category',
            visible: true,
            sortable: true,
            filter: 'select',
            selectOptions: [
              { value: null, text: '' },
              { value: 'GRASS', text: 'Grass' },
              { value: 'MOLD', text: 'Mold' },
              { value: 'TREE', text: 'Tree' },
              { value: 'WEED', text: 'Weed' },
              { value: 'UNIDENTIFIED', text: 'Unidentified' }
            ]
          },
          {
            key: 'allergen.name',
            name: 'Scientific Name',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'allergen.family',
            name: 'Family',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'allergen.commonName',
            name: 'Common Name',
            visible: true,
            sortable: true,
            filter: 'text'
          }
        ]
      },
      scalesFields: [
        {
          key: 'item.category',
          formatter: x => {
            return this.formatCategory(x);
          }
        },
        {
          key: 'range1Begin',
          label: 'Low'
        },
        {
          key: 'range2Begin',
          label: 'Moderate'
        },
        {
          key: 'range3Begin',
          label: 'High'
        },
        {
          key: 'range4Begin',
          label: 'Very High'
        },
        {
          key: 'isEditing',
          label: 'Save'
        }
      ],
    };
  },
  computed: {
  },
  methods: {
    onAllergenItemChanged(allergenItem) {
      let newState = !allergenItem.isActive;
      if (newState) {
        this.query('/graphql/management', {
          query: `
            mutation ($stationAllergen: StationAllergenCreateInputOGT!) {
              createStationAllergen(stationAllergen: $stationAllergen) {
                id
              }
            }`,
          variables: {
            'stationAllergen': {
              stationId: this.$route.params.id,
              allergenId: allergenItem.allergen.id
            }
          }}, (data) => {
            allergenItem.stationAllergen = data.createStationAllergen;
          }, null, 'Enabled Allergen', 'Error Enabling Allergen', allergenItem.allergen.commonName + ' was enabled at this station.');
      } else {
        this.query('/graphql/management', {
          query: `
            mutation ($id: ID!) {
              deleteStationAllergen(id: $id) {
                id
              }
            }`,
          variables: {
            'id': allergenItem.stationAllergen.id
          }}, () => {
          }, null, 'Disabled Allergen', 'Error Disabling Allergen', allergenItem.allergen.commonName + ' was disabled at this station.');
      }
    }
  },
  mounted () {
  }
};
</script>